const namespace = 'CATALOGS';

export const REQUEST_CATALOGS = `${namespace}/REQUEST_CATALOGS`;
export const RECEIVE_CATALOGS_SUCCESS = `${namespace}/RECEIVE_CATALOGS_SUCCESS`;
export const RECEIVE_CATALOGS_FAILURE = `${namespace}/RECEIVE_CATALOGS_FAILURE`;
export const RECEIVE_CATALOG_SUCCESS = `${namespace}/RECEIVE_CATALOG_SUCCESS`;
